import React from "react";
import { currentYear } from "../utilities/date";

const cityNameStyles = {
  fontSize: ".9em",
  textTransform: "uppercase",
  fontWeight: "bold",
};

const addressStyles = {
  fontSize: ".75em",
  fontStyle: "normal",
  lineHeight: "1.5em",
  width: "145px",
};

const Footer = ({ footer }) => {
  const { location1, location2, location3 } = footer;
  return (
    <section className="pt3 px3 pb2 footer clearfix">
      <div>
        <img
          src="/culture-co-op-logo.svg"
          alt="Culture Co-Op Logo"
          style={{ opacity: 0.7 }}
        />
      </div>
      <div className="md-flex mx-auto justify-between">
        <div className="mt1">
          <div className="flex" style={{ fontSize: ".9em" }}>
            <div
              style={{
                paddingRight: "1em",
                marginRight: "1em",
                borderRight: "3px solid #CCC",
              }}
            >
              <span style={cityNameStyles}>{location1}</span>
            </div>
            <div
              style={{
                paddingRight: "1em",
                marginRight: "1em",
                borderRight: "3px solid #CCC",
              }}
            >
              <span style={cityNameStyles}>{location2}</span>
            </div>
            <div>
              <span style={cityNameStyles}>{location3}</span>
            </div>
          </div>
        </div>
        <div className="mt2 left md-right" style={{ fontSize: ".8em", width: "100%" }}>
          <a href="mailto:info@culture.life" style={{ fontWeight: "normal" }}>
            INFO@CULTURE.LIFE
          </a>
          <br />
          <span className="thin" style={{ fontSize: ".85em" }}>
            © Culture Co-op {currentYear(new Date())}
          </span>
        </div>
      </div>
    </section>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js